import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ApiService } from '@services/api.service';
import { UserHelper } from '@helpers/user.helper';
import { UiHelper } from '@helpers/ui.helper';
import { Router } from '@angular/router';

@Component({
  selector: 'sign-out-dialog',
  templateUrl: '../sharedTemplates/sign-out.dialog.html',
})
export class SignOutDialog {
  constructor(
    public dialogRef: MatDialogRef<SignOutDialog>,
    private _ApiService: ApiService,
    private _UserHelper: UserHelper,
    private _router: Router,
    private _UiHelper: UiHelper
  ) {}

  signOutNoClick(): void {
    this.dialogRef.close();
  }

  signOutYesClick(): void {
    this._ApiService
      .signOut()
      .then(result => {
        this._UserHelper.userLogOut();
        this._router.navigate(['/home']);
        this.dialogRef.close();
        this._UiHelper.setRefreshApp();
      })
      .catch(err => console.log('sign-out.dialog', err));
  }
}
